<template>
  <page-header-wrapper>
    <div style="width: 100%;display: flex;">
      <div style="width: 100%;">
        <template>
          <div class="page-header-index-wide">
            <a-form layout="inline">
              <a-row :gutter="24" style="margin-left: 0.5%;margin-right: 0.5%">
                <a-col :md="8" :sm="24" :style="{ marginBottom: '24px'}">
                  <a-radio-group default-value="a" @change="(e) => updateFlag(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      本日视图
                    </a-radio-button>
                    <a-radio-button value="b">
                      本周视图
                    </a-radio-button>
                    <a-radio-button value="c">
                      本月视图
                    </a-radio-button>
                    <a-radio-button value="d">
                      指定日期
                    </a-radio-button>
                  </a-radio-group>
                </a-col>
                <a-col :md="8" :sm="24" v-if="flag === 'd'" :style="{ marginBottom: '24px'}">
                  <a-form-item label="时间" prop="rangeDate">
                    <a-range-picker
                      style="width: 100%"
                      v-model="rangeDate"
                      valueFormat="YYYY-MM-DD"
                      format="YYYY-MM-DD"
                      allow-clear/>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24" v-if="flag === 'd'">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
            <a-row :gutter="24" style="margin-left: 0.5%;margin-right: 0.5%">
              <a-col :span="3" :style="{ marginBottom: '24px'}">
                <a-card style="width: 100%">
                  <p>{{ '会员数' }}</p>
                  <p><font size="6px">{{ form.userCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '驻场客服数' }}</p>
                  <p><font size="6px">{{ form.companyServiceCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '招聘专员数' }}</p>
                  <p><font size="6px">{{ form.topUserCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '推荐官数' }}</p>
                  <p><font size="6px">{{ form.referralsUserCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '厂区面试数' }}</p>
                  <p><font size="6px">{{ form.reportCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '入职成功数' }}</p>
                  <p><font size="6px">{{ form.entryCount }}</font></p>
                </a-card>
              </a-col>
              <a-col :span="3" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p>{{ '入职率' }}</p>
                  <p><font size="6px">{{ form.entryRate }}</font>%</p>
                </a-card>
              </a-col>
            </a-row>
            <a-row :gutter="24" style="margin-left: 0.5%;margin-right: 0.5%">
              <a-col :span="12" :style="{ marginBottom: '24px' }">
                <p><font size="4px">{{ '招聘专员排行榜' }}</font></p>
                <a-table
                  style="margin-top: 16px"
                  :columns="columns"
                  :data-source="form.topUserRank"
                  :pagination="false"
                  :scroll="{ x: 1000, y: 300 }"
                >
                </a-table>
              </a-col>
              <a-col :span="12" :style="{ marginBottom: '24px' }">
                <p><font size="4px">{{ '岗位数据统计' }}</font></p>
                <a-col :span="5" :style="{ marginBottom: '24px' }">
                  <a-card style="width: 100%;height: 240px">
                    <p>{{ '岗位总数' }}</p>
                    <p><font size="6px">{{ form.postCount }}</font></p>
                  </a-card>
                </a-col>
                <a-col :span="5" :style="{ marginBottom: '24px' }">
                  <a-card style="width: 100%;height: 240px">
                    <p>{{ '岗位报名总数' }}</p>
                    <p><font size="6px">{{ form.postApplyCount }}</font></p>
                  </a-card>
                </a-col>
                <a-col :span="5" :style="{ marginBottom: '24px' }">
                  <a-card style="width: 100%;height: 240px">
                    <p>{{ '岗位浏览数' }}</p>
                    <p><font size="6px">{{ form.postBrowseCount }}</font></p>
                  </a-card>
                </a-col>
                <a-col :span="5" :style="{ marginBottom: '24px' }">
                  <a-card style="width: 100%;height: 240px">
                    <p>{{ '新增岗位数' }}</p>
                    <p><font size="6px">{{ form.postAddCount }}</font></p>
                  </a-card>
                </a-col>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <div style="display:flex;justify-content: space-around;">
                <div id="myChart1" :style="{width: '50%', height: '250%'}"></div>
                <div id="myChart2" :style="{width: '50%', height: '250%'}"></div>
              </div>
            </a-row>
          </div>
        </template>
      </div>
    </div>
  </page-header-wrapper>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import ruoyiLogo from '@/assets/projects/ruoyi.png'
import antdvLogo from '@/assets/projects/antdv.png'
import * as echarts from 'echarts'
import {
  getHomeData,
  getHomeLineOneData,
  getHomeLineTwoData
} from '@/api/biz/user'
import ChartCard from './ChartCard'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
    ChartCard
  },
  data() {
    return {
      flag: 'a',
      rangeDate: null,
      targetDate: null,
      form: {
        userCount: null,
        companyServiceCount: null,
        topUserCount: null,
        referralsUserCount: null,
        reportCount: null,
        entryCount: null,
        entryRate: null,
        postCount: null,
        postApplyCount: null,
        postBrowseCount: null,
        postAddCount: null,
        topUserRank: []
      },
      columns: [
        { title: '招聘专员名称', width: 110, dataIndex: 'topUserNickname', key: 'topUserNickname' },
        { title: '新增人数', width: 90, dataIndex: 'addUserCount', key: 'addUserCount' },
        { title: '报名人数', width: 90, dataIndex: 'applyUserCount', key: 'applyUserCount' },
        { title: '报备人数', width: 90, dataIndex: 'reportUserCount', key: 'reportUserCount' },
        { title: '入职人数', width: 90, dataIndex: 'entryUserCount', key: 'entryUserCount' },
        { title: '入职率', width: 90, dataIndex: 'entryRate', key: 'entryRate' }
      ],
      xLine1Data: [],
      yLine1a: [],
      yLine1b: [],
      yLine1c: [],
      xLine2Data: [],
      yLine2a: [],
      yLine2b: [],
      yLine2c: [],
      storeList: [],
      loading: false,
      // 贡献者
      contributors: [
        {
          name: 'wangze',
          avatar: 'https://portrait.gitee.com/uploads/avatars/user/1662/4988475_fuzui_1586973704.png!avatar60',
          email: '73400@163.com'
        }
      ],
      // 赞助
      sponsorList: [
        {
          key: 'RuoYi',
          tab: 'RuoYi'
        },
        {
          key: 'Antdv',
          tab: 'Antdv'
        }
      ],
      noTitleKey: 'RuoYi',
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },
      roleGroup: {},
      postGroup: {},
      // 致谢项目
      projects: [
        {
          logo: ruoyiLogo,
          name: 'RuoYi-Vue',
          description: '基于SpringBoot，Spring Security，JWT，Vue & Element 的前后端分离权限管理系统。',
          website: 'http://ruoyi.vip',
          downloadUrl: 'https://gitee.com/y_project/RuoYi-Vue'
        },
        {
          logo: antdvLogo,
          name: 'Ant Design Vue',
          description: 'An enterprise-class UI components based on Ant Design and Vue. ',
          website: 'https://antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        },
        {
          logo: antdvLogo,
          name: 'Antd Pro Vue',
          description: 'An out-of-box UI solution for enterprise applications as a Vue boilerplate. based on Ant Design of Vue.',
          website: 'https://pro.antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname',
      'userInfo'
    ])
  },
  created() {
    // this.getUser()
    // this.drawLine1()
    this.updateFlag('a')
    this.drawLine1()
    this.drawLine2()
  },
  mounted() {
    this.drawLine1()
    this.drawLine2()
  },
  methods: {
    updateFlag(value) {
      this.flag = value
      debugger
      if (value == 'd') {
        value = 'a'
      }
      getHomeData({
        type: value
      }).then(res => {
        this.form = res.data
      })
    },
    resetQuery() {
      this.rangeDate = null
      this.targetDate = null
      this.updateFlag('a')
      this.flag = 'd'
    },
    handleQuery() {
      var rangeDate = this.rangeDate
      getHomeData({
        beginTime: rangeDate[0],
        endTime: rangeDate[1]
      }).then(res => {
        this.form = res.data
      })
    },
    updateHome(value) {
      this.flag = value
      if (value == 'd') {
        var today = new Date()
        var year = today.getFullYear()// 获取年份
        var month = today.getMonth() + 1// 获取月份
        var day = today.getDate()// 获取日期
        this.targetDate = year + '-' + month + '-' + day
        value = 'a'
      }
      getHomeData({
        type: value
      }).then(res => {
        const data = res.data
      })
    },
    getHome() {
      getHomeData().then(response => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    data(value) {
      if (value === 1) {
        var today = new Date()
        var year = today.getFullYear()// 获取年份
        var month = today.getMonth() + 1// 获取月份
        var day = today.getDate()// 获取日期
        return year + '-' + month + '-' + day + '~' + year + '-' + month + '-' + day
      }
      if (value === 2) {
        var today = new Date()
        var yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        return yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1) + '-' + yesterday.getDate() + '~' + yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1) + '-' + yesterday.getDate()
      }

      if (value === 3) {
        var today = new Date()
        var yesterday = new Date(today.getTime() - 144 * 60 * 60 * 1000)
        var yesterdays = new Date(today.getTime())
        return yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1) + '-' + yesterday.getDate() + '~' + yesterdays.getFullYear() + '-' + (yesterdays.getMonth() + 1) + '-' + yesterdays.getDate()
      }
    },

    onSponsorTabChange(key, type) {
      this[type] = key
    },

    drawLine1() {
      // 获取机构概览
      getHomeLineOneData().then(res => {
        this.xLine1Data = []
        this.yLine1a = []
        this.yLine1b = []
        this.yLine1c = []
        if (res.data) {
          res.data.userNum.forEach((el) => {
            this.xLine1Data.push(el.times)
            this.yLine1a.push(Number(el.nums))
          })
          res.data.reportNum.forEach((el) => {
            this.yLine1b.push(Number(el.nums))
          })
          res.data.entryNum.forEach((el) => {
            this.yLine1c.push(Number(el.nums))
          })
          // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例  myChart1
          const myChart = echarts.init(document.getElementById('myChart1'))
          var option = {
            title: {
              text: '用户概况'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['会员数', '报备数', '入职成功数']
            },

            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xLine1Data
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '会员数',
                type: 'line',
                stack: 'Total',
                data: this.yLine1a
              },
              {
                name: '报备数',
                type: 'line',
                stack: 'Total',
                data: this.yLine1b
              },
              {
                name: '入职成功数',
                type: 'line',
                stack: 'Total',
                data: this.yLine1c
              }
            ]
          }
          // 绘制图表
          option && myChart.setOption(option)
        }
      })
    },
    drawLine2() {
      // 获取机构概览
      getHomeLineTwoData().then(res => {
        this.xLine2data = []
        this.yLine2a = []
        this.yLine2b = []
        this.yLine2c = []
        if (res.data) {
          res.data.entryNum.forEach((el) => {
            this.xLine2data.push(el.times)
            this.yLine2a.push(Number(el.nums))
          })
          res.data.onPostNum.forEach((el) => {
            this.yLine2b.push(Number(el.nums))
          })
          res.data.dimissionNum.forEach((el) => {
            this.yLine2c.push(Number(el.nums))
          })
          // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
          const myChart = echarts.init(document.getElementById('myChart2'))
          var option = {
            title: {
              text: '员工概况'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['入职员工数', '在职员工数', '离职员工数']
            },

            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xLine2data
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '入职员工数',
                type: 'line',
                stack: 'Total',
                data: this.yLine2a
              },
              {
                name: '在职员工数',
                type: 'line',
                stack: 'Total',
                data: this.yLine2b
              },
              {
                name: '离职员工数',
                type: 'line',
                stack: 'Total',
                data: this.yLine2c
              }
            ]
          }
          // 绘制图表
          option && myChart.setOption(option)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

</style>
